import React from "react";
import queryString from "query-string";
import { Row, Col, Container, Button } from "reactstrap";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import { ConfirmationEmailApi, GetRedemptionCodeCSVApi } from "../Code/Data";
import { downloadFile } from '../Code/Utilities';

const DEFAULT_SHARE_BODY = "When meaningful matters, give a charity gift card.";

export default class OrderComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.printEmail = this.printEmail.bind(this);
  }

  async printEmail(purchaseId) {
    let response = await ConfirmationEmailApi(purchaseId);
    console.log("CONFIRMATION EMAIL RESPONSE", response);
    if (response.Succeeded) {
      let content = response.ConfirmationHtml;
      let w = window.open();
      w.document.write(content);
      setTimeout(w.print.bind(w), 500);
    }
  }

  async downloadRedemptionCodes(purchaseId) {
    let response = await GetRedemptionCodeCSVApi(purchaseId);
    console.log("GET REDEMPTION CODE CSV RESPONSE", response);
    if (response.Succeeded) {
      const csv = response.Csv,
        fileName = `RedemptionCodes_Purchase_${purchaseId}.csv`;
      downloadFile(csv, fileName);
    }
  }

  render() {
    const { purchaseId, hasRedemptions } = queryString.parse(
      this.props.location.search
    );

    return (
      <Container className="cart-page">
        <Row>
          <Col md={9} className="left-pane">
            <Row>
              <Col>
                <h1>Thank You So Much For Making A Difference!</h1>
              </Col>
            </Row>
            <Row>
              <Col>
                <h2>Your Order Number is {purchaseId}</h2>
              </Col>
            </Row>
            <Row>
              <Col>
                <p>Please retain this for your records.</p>
              </Col>
            </Row>
            {hasRedemptions === "true" && (
              <Row>
                <Col>
                  <Button
                    onClick={() => this.downloadRedemptionCodes(purchaseId)}>
                    Download Your Redemption Codes
                  </Button>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <Button
                  onClick={e => this.printEmail(purchaseId)}
                  color="primary">
                  Print Confirmation + Tax Receipt
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button href={`/myOrders.aspx`} target="_blank" color="primary">
                  View + Manage My Orders
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <h2>Share this!</h2>
              </Col>
            </Row>
            <Row>
              <Col>
                <p>
                  Support charity and let others know they can make a difference
                  too!
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <FacebookShareButton
                  url={`https://${window.location.host}/#GiveCharityCards`}
                  quote={DEFAULT_SHARE_BODY}>
                  <FacebookIcon size={32} round={true} />
                </FacebookShareButton>
                <TwitterShareButton
                  url={`https://${window.location.host}/#GiveCharityCards`}
                  title="I just made a difference with CharityChoice!">
                  <TwitterIcon size={32} round={true} />
                </TwitterShareButton>
                <WhatsappShareButton
                  url={`https://${window.location.host}/#GiveCharityCards`}
                  title="I just made a difference with CharityChoice!">
                  <WhatsappIcon size={32} round={true} />
                </WhatsappShareButton>
                <EmailShareButton
                  url={`https://${window.location.host}/#GiveCharityCards`}
                  subject="I just made a difference with CharityChoice!"
                  body={DEFAULT_SHARE_BODY}>
                  <EmailIcon size={32} round={true} />
                </EmailShareButton>
              </Col>
            </Row>
          </Col>
          <Col md={3} className="right-pane">
            <p>
              Charity Choice is a pioneer in charity gift cards, a project of
              the Special Kids Fund (501c3) benefiting special needs children.
            </p>
          </Col>
        </Row>
      </Container>
    );
  }
}
